import Service from "../../services";

// initial state
const DevData = {
  name: "DevData",
  stateFactory: true,
  namespaced: true,
  state: {
    // dataDev:{
    //     id:'',
    //     name_th: '',
    //     name_en: '',
    //     description_th: '',
    //     description_en: '',
    //     reference_th: '',
    //     reference_en: '',
    //     howto_th: '',
    //     howto_en: '',
    //     file_path: '',
    //     updated_at: '',
    // },
    dataDev: [],
    dataDevPaginate: [],
    dataDevContent: [],
    dataDevContentExcel: [],
  },
  mutations: {
    SET_DEV_DATA(state, data) {
      state.dataDev = [];
      state.dataDev = data;
      // eslint-disable-next-line no-console
      console.log("state.dataDev", state.dataDev);
    },
    SET_DEV_DATA_CONTENT(state, data) {
      state.dataDevContent = [];
      state.dataDevContent = data;
      // eslint-disable-next-line no-console
      console.log("state.dataDevContent", state.dataDevContent);
    },
    SET_DEV_DATA_CONTENT_EXCEL(state, data) {
      state.dataDevContentExcel = [];
      state.dataDevContentExcel = data;
      // eslint-disable-next-line no-console
      console.log("state.dataDevContent", state.dataDevContentExcel);
    },
  },
  actions: {
    async clearState(state) {
      state.dataDev = [];
      state.dataDevContent = [];
      console.log("state= clear");
    },

    async onGetAllDevData({ commit }) {
      var items = [];
      var groups = null;
      await Service.dataDev.getGroupCkan().then((res) => {
        groups = res;
      });
      for (let i = 0; i < groups.length; i++) {
        await Service.dataDev.getDevDataCkan(groups[i]["name"]).then((res) => {
          items = items.concat(res.result.results)
        });
      }
      commit("SET_DEV_DATA", items);
      return items;
    },
    
    onGetDataDevContent({ commit }, id) {
      return Service.dataDev.getDataContent(id).then((res) => {
        commit("SET_DEV_DATA_CONTENT", res);
        return res;
      });
    },
    onGetDataDevContentExcel({ commit }, id) {
      return Service.dataDev.getDataContentExcel(id).then((res) => {
        commit("SET_DEV_DATA_CONTENT_EXCEL", res);
        return res;
      });
    },
    onAddDevData(data) {
      let data_create = data;
      console.log("data_create", typeof data_create);
      console.log("data_create", data_create);
      return Service.dataDev.addDevData(data_create).then((res) => {
        return res;
      });
    },
    // eslint-disable-next-line no-unused-vars
    onUpdateDevData({ commit }, data) {
      let id = data.id;
      let data_update = data;
      return Service.dataDev.updateDevData(id, data_update).then((res) => {
        return res;
      });
    },
    // eslint-disable-next-line no-unused-vars
    onDeleteDevData({ commit }, id) {
      return Service.dataDev.deleteDevData(id).then((res) => {
        return res;
      });
    },
    onImportExcel({ commit }, data) {
      return Service.dataDev.importExcel(data).then((res) => {
        return res;
      });
    },
  },
};
export default DevData;
